import { render, staticRenderFns } from "./gSwiperCommon2.vue?vue&type=template&id=2ec3df26&"
import script from "./gSwiperCommon2.vue?vue&type=script&lang=js&"
export * from "./gSwiperCommon2.vue?vue&type=script&lang=js&"
import style0 from "./gSwiperCommon2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports